import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { EModAsideIndentSide, IModAsideIndentSide } from '../types'

const Block = styled.div<StyledProps<IModAsideIndentSide>>`
  ${sm.mod(EModAsideIndentSide.left)`
    margin-left: ${sv.spacing.xlarge};
  `};

  ${sm.mod(EModAsideIndentSide.right)`
    margin-right: ${sv.spacing.xlarge};
  `};
`

export default { Block }
